export default function parseJsonSafe(str, reviver) {
    try {
        return JSON.parse(str, reviver);
    } catch (err) {
        return null;
    }
}
